import * as React from "react";
import { EnantisEmailLink, IEnantisEmailLinkProps } from "./enantis-commons";
import Box, { IBoxProps } from "../../parts/Box";
import { ll_url } from "../../tools";

/**
 * The commercial section properties.
 */
export type IEnantisSectionProps = Omit<IBoxProps, "children" | "title"> &
  IEnantisEmailLinkProps & {
  /** The title displayed in the box. */
  title?: string;
};

/**
 * The commercial section component.
 */
export const EnantisSection: React.FC<IEnantisSectionProps> = (props) => {
  const boxProps: Omit<IBoxProps, "children"> = {
    ...props,
    title: props.title ?? "Commercial version",
  };
  return (
    <Box {...boxProps}>
      <p>
        <strong>License for commercial use</strong>
      </p>
      <p>
        Contact us: <EnantisEmailLink {...props} />
      </p>
      <div style={{textAlign: "center"}}>
        <a href="https://www.enantis.com/products/#software" target="_blank">
          <img src={ll_url('/images/logos/enantis_logo.png')} style={{width: "80px"}}/>
        </a>
      </div>
    </Box>
  );
};
